function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var PhotoTemplate = require('./photo.template');
var Photo = /*#__PURE__*/function () {
  function Photo(app, mod) {
    _classCallCheck(this, Photo);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, true);
    this.overlay["class"] = 'saito-overlay saitosign-overlay saitosign-photo-host';
    this.hooks = {};
    this.stream = null;
    this.image = '';
    this.mirror = false;
    this.mode = 'opening';
    this.shot = 0;
    this.settled = false;
  }
  return _createClass(Photo, [{
    key: "open",
    value: function open() {
      var _this = this;
      var hooks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.hooks = hooks;
      this.settled = false;
      this.image = '';
      this.overlay.show(PhotoTemplate(), function () {
        if (_this.settled) {
          return;
        }
        _this.settled = true;
        _this.release();
        if (_this.hooks.onClose) {
          _this.hooks.onClose();
        }
      });
      this.attachEvents();
      this.startCamera();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      var root = this.root();
      if (!root || root.dataset.bound === '1') {
        return;
      }
      root.dataset.bound = '1';
      root.addEventListener('click', function (event) {
        var button = event.target.closest('[data-photo-action]');
        if (!button || button.disabled) {
          return;
        }
        var action = button.dataset.photoAction;
        if (action === 'capture') {
          _this2.capture();
        } else if (action === 'accept') {
          _this2.accept();
        } else if (action === 'reject') {
          _this2.reject();
        } else if (action === 'again') {
          _this2.again();
        } else if (action === 'close') {
          _this2.dismiss();
        }
      });
    }
  }, {
    key: "startCamera",
    value: function () {
      var _startCamera = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var video, still, stream, _t, _t2, _t3;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!this.settled) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              this.mode = 'opening';
              this.mirror = false;
              this.setStatus('Opening the camera…');
              this.setActions([]);
              video = this.video();
              still = this.still();
              if (video) {
                video.hidden = true;
                video.classList.remove('mirror');
              }
              if (still) {
                still.hidden = true;
                still.removeAttribute('src');
              }
              this.setCount('');
              if (!(!navigator.mediaDevices || typeof navigator.mediaDevices.getUserMedia !== 'function')) {
                _context.n = 2;
                break;
              }
              this.fail('This browser cannot open a camera.');
              return _context.a(2);
            case 2:
              if (!(typeof window.isSecureContext === 'boolean' && !window.isSecureContext)) {
                _context.n = 3;
                break;
              }
              this.fail('The camera can only be opened on a secure page.');
              return _context.a(2);
            case 3:
              _context.p = 3;
              _context.n = 4;
              return navigator.mediaDevices.getUserMedia({
                audio: false,
                video: {
                  facingMode: 'user'
                }
              });
            case 4:
              stream = _context.v;
              this.mirror = true;
              _context.n = 10;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              if (!this.settled) {
                _context.n = 6;
                break;
              }
              stopStream(stream);
              return _context.a(2);
            case 6:
              if (!denied(_t)) {
                _context.n = 7;
                break;
              }
              this.fail('Camera access was denied. Allow the camera in the browser to take a photo.');
              return _context.a(2);
            case 7:
              _context.p = 7;
              _context.n = 8;
              return navigator.mediaDevices.getUserMedia({
                audio: false,
                video: true
              });
            case 8:
              stream = _context.v;
              this.mirror = false;
              _context.n = 10;
              break;
            case 9:
              _context.p = 9;
              _t2 = _context.v;
              if (!this.settled) {
                this.fail(cameraMessage(_t2));
              }
              return _context.a(2);
            case 10:
              if (!(this.settled || this.mode !== 'opening')) {
                _context.n = 11;
                break;
              }
              stopStream(stream);
              return _context.a(2);
            case 11:
              this.stream = stream;
              if (!video) {
                _context.n = 15;
                break;
              }
              video.srcObject = stream;
              video.hidden = false;
              video.classList.toggle('mirror', this.mirror);
              _context.p = 12;
              _context.n = 13;
              return video.play();
            case 13:
              _context.n = 15;
              break;
            case 14:
              _context.p = 14;
              _t3 = _context.v;
            case 15:
              this.mode = 'preview';
              this.setStatus('Look at the camera, then capture.');
              this.setActions([['capture', 'Capture', 'primary']]);
            case 16:
              return _context.a(2);
          }
        }, _callee, this, [[12, 14], [7, 9], [3, 5]]);
      }));
      function startCamera() {
        return _startCamera.apply(this, arguments);
      }
      return startCamera;
    }()
  }, {
    key: "capture",
    value: function capture() {
      if (this.settled || this.mode !== 'preview') {
        return;
      }
      var shot = ++this.shot;
      this.mode = 'countdown';
      this.setStatus('');
      this.setActions([]);
      this.runCountdown(shot);
    }
  }, {
    key: "runCountdown",
    value: function () {
      var _runCountdown = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(shot) {
        var _i, _arr, step, image, still, video;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _i = 0, _arr = [3, 2, 1];
            case 1:
              if (!(_i < _arr.length)) {
                _context2.n = 4;
                break;
              }
              step = _arr[_i];
              if (!(this.settled || this.shot !== shot || this.mode !== 'countdown')) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              this.setCount(String(step));
              _context2.n = 3;
              return wait(1000);
            case 3:
              _i++;
              _context2.n = 1;
              break;
            case 4:
              if (!(this.settled || this.shot !== shot || this.mode !== 'countdown')) {
                _context2.n = 5;
                break;
              }
              return _context2.a(2);
            case 5:
              this.setCount('');
              image = grabFrame(this.video(), this.mirror);
              this.stopCamera();
              if (image) {
                _context2.n = 6;
                break;
              }
              this.fail('The photograph could not be captured.');
              return _context2.a(2);
            case 6:
              this.image = image;
              this.mode = 'review';
              still = this.still();
              video = this.video();
              if (video) {
                video.hidden = true;
              }
              if (still) {
                still.src = image;
                still.hidden = false;
              }
              this.setStatus('Use Photograph?', true);
              this.setActions([['reject', 'Reject', ''], ['again', 'Take Again', ''], ['accept', 'Accept', 'primary']]);
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function runCountdown(_x) {
        return _runCountdown.apply(this, arguments);
      }
      return runCountdown;
    }()
  }, {
    key: "again",
    value: function again() {
      if (this.settled) {
        return;
      }
      this.shot += 1;
      this.image = '';
      this.stopCamera();
      this.startCamera();
    }
  }, {
    key: "accept",
    value: function accept() {
      if (this.settled || !this.image) {
        return;
      }
      var image = this.image;
      this.settled = true;
      this.release();
      this.overlay.close();
      if (this.hooks.onAccept) {
        this.hooks.onAccept(image);
      }
    }
  }, {
    key: "reject",
    value: function reject() {
      if (this.settled) {
        return;
      }
      this.image = '';
      this.settled = true;
      this.release();
      this.overlay.close();
      if (this.hooks.onReject) {
        this.hooks.onReject();
      }
    }
  }, {
    key: "dismiss",
    value: function dismiss() {
      if (this.settled) {
        return;
      }
      this.settled = true;
      this.release();
      this.overlay.close();
      if (this.hooks.onClose) {
        this.hooks.onClose();
      }
    }
  }, {
    key: "fail",
    value: function fail(message) {
      if (this.settled) {
        return;
      }
      this.mode = 'error';
      this.shot += 1;
      this.stopCamera();
      var video = this.video();
      var still = this.still();
      if (video) {
        video.hidden = true;
      }
      if (still) {
        still.hidden = true;
      }
      this.setCount('');
      this.setStatus(message);
      this.setActions([['close', 'Close', '']]);
    }
  }, {
    key: "release",
    value: function release() {
      this.shot += 1;
      this.stopCamera();
    }
  }, {
    key: "stopCamera",
    value: function stopCamera() {
      var video = this.video();
      if (video) {
        video.pause();
        video.srcObject = null;
      }
      stopStream(this.stream);
      this.stream = null;
    }
  }, {
    key: "root",
    value: function root() {
      return document.querySelector('.saitosign-photo');
    }
  }, {
    key: "video",
    value: function video() {
      var root = this.root();
      return root ? root.querySelector('[data-photo-video]') : null;
    }
  }, {
    key: "still",
    value: function still() {
      var root = this.root();
      return root ? root.querySelector('[data-photo-still]') : null;
    }
  }, {
    key: "setStatus",
    value: function setStatus(message) {
      var _this$root;
      var heading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var note = (_this$root = this.root()) === null || _this$root === void 0 ? void 0 : _this$root.querySelector('[data-photo-status]');
      if (!note) {
        return;
      }
      note.hidden = false;
      note.classList.toggle('heading', heading);
      note.textContent = message || "\xA0";
    }
  }, {
    key: "setCount",
    value: function setCount(value) {
      var _this$root2;
      var count = (_this$root2 = this.root()) === null || _this$root2 === void 0 ? void 0 : _this$root2.querySelector('[data-photo-count]');
      if (!count) {
        return;
      }
      count.textContent = value || '';
      count.hidden = !value;
    }
  }, {
    key: "setActions",
    value: function setActions(actions) {
      var _this$root3;
      var bar = (_this$root3 = this.root()) === null || _this$root3 === void 0 ? void 0 : _this$root3.querySelector('[data-photo-actions]');
      if (!bar) {
        return;
      }
      bar.innerHTML = actions.map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 3),
          action = _ref2[0],
          label = _ref2[1],
          tone = _ref2[2];
        var primary = tone === 'primary' ? ' primary' : '';
        return "<button type=\"button\" class=\"photo-action".concat(primary, "\" data-photo-action=\"").concat(action, "\">").concat(label, "</button>");
      }).join('');
    }
  }]);
}();
function stopStream(stream) {
  if (!stream || typeof stream.getTracks !== 'function') {
    return;
  }
  stream.getTracks().forEach(function (track) {
    return track.stop();
  });
}
function denied(err) {
  var name = String((err === null || err === void 0 ? void 0 : err.name) || '');
  return name === 'NotAllowedError' || name === 'PermissionDeniedError' || name === 'SecurityError';
}
function cameraMessage(err) {
  var name = String((err === null || err === void 0 ? void 0 : err.name) || '');
  if (denied(err)) {
    return 'Camera access was denied. Allow the camera in the browser to take a photo.';
  }
  if (name === 'NotFoundError' || name === 'DevicesNotFoundError' || name === 'OverconstrainedError') {
    return 'No camera is available on this device.';
  }
  return 'The camera could not be opened.';
}
function grabFrame(video, mirror) {
  var sourceW = (video === null || video === void 0 ? void 0 : video.videoWidth) || 0;
  var sourceH = (video === null || video === void 0 ? void 0 : video.videoHeight) || 0;
  if (!sourceW || !sourceH) {
    return '';
  }
  var scale = Math.min(1, 1280 / Math.max(sourceW, sourceH));
  var width = Math.max(1, Math.round(sourceW * scale));
  var height = Math.max(1, Math.round(sourceH * scale));
  var canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  var ctx = canvas.getContext('2d');
  if (!ctx) {
    return '';
  }
  if (mirror) {
    ctx.translate(width, 0);
    ctx.scale(-1, 1);
  }
  ctx.drawImage(video, 0, 0, width, height);
  try {
    return canvas.toDataURL('image/jpeg', 0.85);
  } catch (err) {
    return '';
  }
}
function wait(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}
module.exports = Photo;